import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { smsDonationActions } from "redux/actions/SMS Donation/smsDonationActions";

interface SliderSliceProps {
  project?: any;
  showSmsDonation: boolean;
  setShowSmsDonation: React.Dispatch<React.SetStateAction<boolean>>;
  showDonateNow: boolean;
  setShowDonateNow: React.Dispatch<React.SetStateAction<boolean>>;
}

const SliderSlice = ({
  project,
  showSmsDonation,
  setShowSmsDonation,
  showDonateNow,
  setShowDonateNow,
}: SliderSliceProps) => {
  const dispatch: any = useDispatch();
  const { t, i18n } = useTranslation();

  return (
    <div
      data-aos="fade-up"
      data-aos-duration="900"
      className="h-[220px] lg:min-h-[450px] 2xl:min-h-[550px] flex items-center lg:items-end justify-center lg:justify-end"
    >
      <img
        src={project?.thumbnail_url}
        alt="Project Thumbnail"
        className="absolute top-0 left-0 z-[-5] w-full h-full"
      />
      <div
        className={` absolute bottom-[-20%] left-[-8%] lg:bottom-0 lg:left-0  w-full h-full pt-[420px] md:pt-0  pb-[70px] lg:pb-[60px] flex  items-center lg:items-end  justify-end gap-7 ${
          i18n.language === "en"
            ? "font-Poppins lg:pr-[180px]"
            : "font-Almarai lg:pl-[180px]"
        } font-[600]`}
      >
        {/* button  */}
        <div>
          <button
            onClick={() => setShowDonateNow(!showDonateNow)}
            className={`w-[100px] h-[45px] text-[14px] lg:w-[170px] lg:h-[55px] bg-[#B07F4A] lg:text-[18px] rounded-[10px] font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[600] text-white hover:bg-[#614629] duration-300 animate-pulse hover:animate-none`}
          >
            {t("Donate Now")}
          </button>
        </div>

        {/* button  */}
        <div>
          <button
            onClick={() => {
              setShowSmsDonation(!showSmsDonation);
              dispatch(
                smsDonationActions({
                  id: project?.project_id,
                  donation_type: project?.project_type,
                })
              );
            }}
            className={`h-[45px] text-[14px] lg:h-[55px] bg-[#E9EBEC] lg:text-[18px] rounded-[10px] ${
              i18n.language === "en"
                ? "font-Poppins w-[152px]"
                : "font-Almarai w-[180px] lg:w-[220px]"
            } font-[600] text-second_color hover:bg-[#a9adaf] duration-300 animate-pulse hover:animate-none`}
          >
            {t("SMS Donation")}
          </button>
        </div>

        <div></div>
      </div>
    </div>
  );
};

export default SliderSlice;
